import { Form, Formik, Field } from 'formik';
import React, { useContext } from 'react';
import * as Yup from 'yup';
import { CommissionPercentageInput, InputTextComponent } from '../../../components/prime-formik';
import {
  MAX_CREDIT_COMMISSION_PERCENTAGE,
  MAX_NO_LIMIT_COMMISSION_PERCENTAGE,
  MINIMUM_COMMISSION_PERCENTAGE,
  MINIMUM_CREDIT_COMMISSION_PERCENTAGE,
} from '../../../shared/Constants';
import { Button } from 'primereact/button';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { growlErrors } from '../../../utils/NotificationUtil';

const UPDATE_GP_COMMISSION_PERCENTAGES_MUTATION = gql`
  mutation updateGpCommissionPercentagesMutation($input: UpdateGpCommissionPercentageInput!) {
    updateGpCommissionPercentages(input: $input) {
      account {
        id
      }
    }
  }
`;

const EditAgreedCommission = ({ partner, cancelEditMode }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [updateGpCommissionPercentages] = useMutation(UPDATE_GP_COMMISSION_PERCENTAGES_MUTATION);

  const {
    id,
    name,
    creditCommissionPercentage,
    noLimitCommissionPercentage,
    superCreditsCommissionPercentage,
  } = partner;

  const initialValues = {
    id,
    name,
    creditCommissionPercentage,
    noLimitCommissionPercentage,
    superCreditsCommissionPercentage,
  };

  const validationSchema = Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
    creditCommissionPercentage: Yup.number().required(),
    noLimitCommissionPercentage: Yup.number().required(),
    superCreditsCommissionPercentage: Yup.number().required(),
  });

  const handleCommissionEdit = async (values) => {
    try {
      await updateGpCommissionPercentages({
        variables: {
          input: {
            gscId: currentAccount,
            gpId: id,
            creditCommissionPercentage: values.creditCommissionPercentage,
            noLimitCommissionPercentage: values.noLimitCommissionPercentage,
            superCreditsCommissionPercentage: values.superCreditsCommissionPercentage,
          },
        },
        refetchQueries: ['agreedCommissionsQuery'],
      });

      cancelEditMode();
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  return (
    <div className=" margin-bottom-0-5">
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleCommissionEdit(values);
        }}
      >
        {({ handleSubmit }) => {
          return (
            <Form className="flex-space-between" onSubmit={handleSubmit}>
              <div>
                <Field id="name" name="name" component={InputTextComponent} readOnly={true} />
              </div>
              <div>
                <Field id="id" name="id" component={InputTextComponent} readOnly={true} />
              </div>
              <div>
                <Field
                  id="creditCommissionPercentage"
                  name="creditCommissionPercentage"
                  type="number"
                  min={MINIMUM_CREDIT_COMMISSION_PERCENTAGE}
                  max={MAX_CREDIT_COMMISSION_PERCENTAGE}
                  component={CommissionPercentageInput}
                />
              </div>
              <div>
                <Field
                  id="noLimitCommissionPercentage"
                  name="noLimitCommissionPercentage"
                  type="number"
                  min={MINIMUM_COMMISSION_PERCENTAGE}
                  max={MAX_NO_LIMIT_COMMISSION_PERCENTAGE}
                  component={CommissionPercentageInput}
                />
              </div>
              <div>
                <Button icon="pi pi-check" className="p-button-success" />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditAgreedCommission;
